/*
 * ACC_Calminity_LP_01
 *
 * The only script this landing page needs: honour prefers-reduced-motion on the autoplaying
 * story videos. CSS cannot remove an autoplay attribute, so this cannot be done in the stylesheet.
 *
 * init(scope) + a dataset marker + an explicitly bound shopify:section:load, because the theme
 * editor re-renders a single section without reloading the page. Scoped to e.target so a reload
 * of one section never re-processes videos in the others.
 */
(function () {
  var MARK = 'cal01Video';
  var QUERY = 'video.cal01-story__video';

  function prefersReducedMotion() {
    return !!(
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function calm(video) {
    video.removeAttribute('autoplay');
    video.autoplay = false;
    video.loop = false;
    // Give the visitor a way to play it themselves rather than removing the media outright.
    video.controls = true;
    try { video.pause(); } catch (e) { /* pause before metadata can reject; nothing to undo */ }
  }

  function liven(video) {
    video.controls = false;
    video.loop = true;
    video.autoplay = true;
    var play = video.play();
    if (play && typeof play.catch === 'function') {
      // A blocked autoplay is normal, not an error worth surfacing.
      play.catch(function () {});
    }
  }

  function apply(video) {
    if (prefersReducedMotion()) { calm(video); } else { liven(video); }
  }

  function init(scope) {
    var root = scope || document;
    var videos = root.querySelectorAll ? root.querySelectorAll(QUERY) : [];
    Array.prototype.forEach.call(videos, function (video) {
      if (video.dataset[MARK]) return;
      video.dataset[MARK] = '1';
      apply(video);
    });
  }

  init(document);

  if (!window.Cal01VideoBound) {
    window.Cal01VideoBound = true;

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });

    // A visitor can flip the OS setting mid-visit. Re-apply to every already-marked video.
    if (window.matchMedia) {
      var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
      var onChange = function () {
        Array.prototype.forEach.call(document.querySelectorAll(QUERY), apply);
      };
      if (mq.addEventListener) {
        mq.addEventListener('change', onChange);
      } else if (mq.addListener) {
        mq.addListener(onChange);
      }
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { init: init, apply: apply, calm: calm, liven: liven };
  }
})();